import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=8e6c26ce&scoped=true&"
import script from "./Markets.vue?vue&type=script&setup=true&lang=js&"
export * from "./Markets.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Markets.vue?vue&type=style&index=0&id=8e6c26ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6c26ce",
  null
  
)

export default component.exports